import productUploadLogsApi from './productUploadLogsApi.js';

export default function* productUploadLogsRequest() {
  console.log(`[productUploadLogsRequest Saga] Submitting request to get productUploadLogs.`);

  return yield productUploadLogsApi();
}
